export default "__VITE_ASSET__ClADDuJM__"